import { Query } from 'react-query';

export const resetQueryFn = (query: Query, ...keys: any[]): boolean => {
  if (!keys?.length) {
    console.error("No query keys provided for reset function. It's probably an error.");
  }
  return (keys ?? []).some((key) => query.queryKey.includes(key));
};
